<template>
  <div class="view contentBody">
    <div class="title">运费管理</div>
    <div class="content">
      <div class="content-tab-box">
        <span :class="meaulistTab.firstTab==item?'content-tab-box-active':''" @click="tabCurrentFn(item)"
              v-for="(item,index) in meaulistTab.tab" :key="item">{{index}}</span>
      </div>
      <div v-for="item in meaulistTab.tab" :key="item">
        <component v-bind:is="item" v-if="meaulistTab.firstTab==item"></component>
      </div>
    </div>
  </div>
</template>
<script>
import freightTemplateList from "./freightTemplateList.vue";
import shippingSettings from "./shippingSettings.vue";
let tabBox = {
  '运费模板': {property: 'freightTemplateList'},
  '包邮设置': {property: 'shippingSettings'}
}

export default {
  name: "freightmanage",
  components: {
    freightTemplateList,
    shippingSettings
  },
  data() {
    return {
      meaulistTab: this.meaulist.meaulistGet(this, tabBox),
      activeName:''
    };
  },
  created() {
    this.inittab();
  },
  methods: {
    inittab() {
      this.activeName =
        this.$route.query.tab !== undefined
          ? this.$route.query.tab
          : "freightTemplateList";
    },
    tabCurrentFn(index){
      this.meaulistTab.firstTab = index
    }
  }
};
</script>
